import React from "react";

import css from "./Divider.module.scss";

const Divider = () => <div aria-hidden="true" className={css.Divider} />;

export default Divider;
